<template>
  <div>
    <h1 class="page-title text-left">Larval Identification Details</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link :to="{ name: 'data-larval-identification' }" class="pull-right ml-10"><i class="fa fa-list"></i></router-link>
          <i class="fa fa-pencil pointer pull-right" v-on:click="form.showEdit({id: id, list: true})"></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">

          <dt>Larvicide</dt>
          <dd><router-link :to="{ name: 'data-larvicide-details', params: {id: form.data.larvicideId} }">view</router-link></dd>

          <dt>Id Date</dt>
          <dd>{{ form.data.idDate | date }}</dd>

          <dt>Identified By</dt>
          <dd>{{ form.data.identifiedBy }}</dd>

          <dt>Mosquito Species</dt>
          <dd>
            <div v-for="count in form.data.species">
              {{ mosquitoName(count.mosquito) }} : {{ count.count }}
            </div>
          </dd>

        </dl>
      </div>
    </div>

    <site-form :form="form"></site-form>


  </div>
</template>

<script>
  import LarvalIdentificationService from '@/services/LarvalIdentificationService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/larval_identification';

  import store from '@/store';

  export default {
    name: 'larval_identification_details',

    components: {
      siteForm
    },

    props: ['id'],

    data() {
      return {
        form: new Form(
          LarvalIdentificationService,
          {
            larvicideId: 123,
          })
      }
    },

    methods: {
      mosquitoName(id) {
        return this.$store.getters.mosquitoNameById(id)
      },
    },

    mounted() {

      loader.lookups()
        .then(() => {
          this.form.getDetails(this.id);
        });
    }

  }
</script>

<style lang="scss">

</style>
